import React from "react";
import Login from "../pages/Login";
import HomePageOne from "../pages/HomePageOne";
import TableReservation from "../pages/TableReservation";
import ViewReservation from "../pages/ViewReservation";
import BookReservation from "../pages/BookReservation";
import ReservationSettings from "../pages/ReservationSettings";
import AlterReservationSettings from "../pages/AlterReservationSettings";
import EditReservationSettings from "../pages/EditReservationSettings";
import CreatePromotions from "../pages/CreatePromotions";
import PromotionList from "../pages/PromotionList";
import EditPromotion from "../pages/EditPromotion";
import Contents from "../pages/Contents";
import UpdateContents from "../pages/UpdateContents";
import CreateContent from "../pages/createContents";
import Events from "../pages/Events";
import AddEvents from "../pages/AddEvents";

const AppRoutes = [
  {
    isProtectedAuth: false,
    path: "/login",
    element: <Login />,
  },
  {
    isProtected: true,
    path: "/home",
    element: <HomePageOne />,
  },
  {
    isProtected: true,
    path: "/",
    element: <HomePageOne />,
  },
  {
    isProtected: true,
    path: "/table-enquiry-list",
    element: <TableReservation />,
  },
  {
    isProtected: true,
    path: "/scheduler",
    element: <TableReservation />,
  },
  {
    isProtected: true,
    path: "/view-reservation/:id",
    element: <ViewReservation />,
  },
  {
    isProtected: true,
    path: "/edit-promotion/:id",
    element: <EditPromotion />,
  },
  {
    isProtected: true,
    path: "/add-reservation",
    element: <BookReservation />,
  },
  {
    isProtected: true,
    path: "/create-promotion",
    element: <CreatePromotions />,
  },
  {
    isProtected: true,
    path: "/promotion-list",
    element: <PromotionList />,
  },

  {
    isProtected: true,
    path: "/reservation-settings",
    element: <ReservationSettings />,
  },
  {
    isProtected: true,
    path: "/create-reservation-settings",
    element: <AlterReservationSettings />,
  },
  {
    isProtected: true,
    path: "/edit-reservation-settings",
    element: <EditReservationSettings />,
  },
  {
    isProtected: true,
    path: "/contents",
    element: <Contents />,
  },
  {
    isProtected: true,
    path: "/update-content/:id",
    element: <UpdateContents />,
  },
  {
    isProtected: true,
    path: "/create-content",
    element: <CreateContent />,
  },
  {
    isProtected: true,
    path: "/events",
    element: <Events />,
  },
  {
    isProtected: true,
    path: "/create-new-event",
    element: <AddEvents />,
  },
];

export default AppRoutes;
